module.exports = __webpack_public_path__ + "static/conflict-41f92e24304372c858ead56293145827.png";